<template>
<v-card flat>
    <v-card-text class="title mt-10">
        Account Details
    </v-card-text>
    <v-divider></v-divider>
    <div class="pa-5">
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" v-model="account.name" :disabled="IsTrue" :rules="Rules" prepend-inner-icon="mdi-account" outlined label="Full Name" required dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" v-model="email" outlined label="Email" prepend-inner-icon="mdi-email" :disabled="true" value="hemant.mann@trackier.com" required dense></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                    <v-text-field class="border-radius" v-model="account.company" :disabled="IsTrue" :rules="Rules" prepend-inner-icon="mdi-domain" outlined label="Company Name" required dense></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                    <!-- <v-text-field class="border-radius" v-model="account.country" :disabled="IsTrue" :rules="Rules" prepend-inner-icon="mdi-domain" outlined label="Company Name" required></v-text-field> -->
                     <v-autocomplete v-model="account.country" class="ma-0 border-radius" label="Country" :disabled="IsTrue" clearable :items="country" outlined dense item-text="Country Name" item-value="Country">
                        <template v-slot:item="{item}" style="text-transform: lowercase">
                            <span :class="`flag-icon flag-icon-${item.Country.toLowerCase()} mr-2`"></span>
                            <span class="mr-2">[{{item.Country}}]</span>
                            <span>{{item["Country Name"]}}</span>
                        </template>
                        <template v-slot:selection="data">
                            <span :class="`flag-icon flag-icon-${data.item.Country.toLowerCase()} mr-2`"></span>
                            <span class="mr-2">[{{data.item.Country}}]</span>
                            <span>{{data.item["Country Name"]}}</span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" v-model="account.state" :disabled="IsTrue" :rules="Rules" prepend-inner-icon="mdi-domain" outlined label="State" required dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field class="border-radius" v-model="account.city" :disabled="IsTrue" :rules="Rules" prepend-inner-icon="mdi-domain" outlined label="City" required dense></v-text-field>
                </v-col>
            </v-row>
        </v-form>
        <v-card-actions class="px-0">
            <v-btn color="blue darken-1" :loading="IsTrue" class="px-4" dark @click="accountDetails">Submit</v-btn>
        </v-card-actions>
    </div>
</v-card>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from 'vuex'
export default {
    data: () => ({
        email: '',
        IsTrue: false,
        Rules: [
            v => !!v || 'Field is required',
            v => (v && v.length >= 3) || 'must be less than 3 characters',
        ],
        selectCityList: [],
        account: {
            company: "",
            name: "",
            country: "",
            city: "",
            state: ""
        },
        valid: false
    }),
    computed: {
        ...mapGetters(['timeZone', 'country', 'city', 'userAccount'])
    },
    async mounted() {
        if (localStorage.getItem('userToken')) {
            await this.userDetails()
        }
    },
    methods: {
        ...mapMutations(['UserAccount', 'SnackbarSuccess']),
        ...mapActions(['PostResponse']),
        async accountDetails() {
            if (this.$refs.form.validate()) {
                this.IsTrue = true
                try {
                    let value = {
                        url: '/internal/v2/account',
                        data: this.account
                    }
                    const data = (await this.PostResponse(value)).data
                    if (data.success) {
                        localStorage.setItem("account", JSON.stringify(data.data.account))
                        localStorage.setItem("user", JSON.stringify(data.data.user))
                        localStorage.setItem("credit", JSON.stringify(data.data.credit))
                        this.UserAccount()
                        this.SnackbarSuccess(data)
                        this.IsTrue = false
                    } else {
                        this.UserAccount()
                        this.IsTrue = false
                    }
                } catch (err) {
                    console.log(err)
                    this.IsTrue = false
                }
            }
        },
        userDetails() {
            this.email = JSON.parse(window.localStorage.getItem('user')).email
            this.account.name = JSON.parse(window.localStorage.getItem('user')).name
            //this.account.created = JSON.parse(window.localStorage.getItem('user')).created
            this.account.company = JSON.parse(window.localStorage.getItem('account')).name
            this.account.country = JSON.parse(window.localStorage.getItem('account')).region.country
            this.account.city = JSON.parse(window.localStorage.getItem('account')).region.city
            this.account.state = JSON.parse(window.localStorage.getItem('account')).region.state
        }
    }
}
</script>
